<template>
    <div v-bind:class="['dropdown-block', { 'dropdown-menu-open': dropDownOpen, 'top': isOverflown, }, {'dropdown-error': hasErrors && !dropDownOpen}]" 
         :name="name" v-click-outside="onClickOutside">
        <input type="text" @click="onDropDownOpen()"
               :placeholder="selectedText"
               ref="SearchInput"
               :name="name"
               class="input-text"
               @input="onChangeSearchInput($event)"
               @keydown.enter.prevent=""
               @blur="$emit('blur')"
               v-model="searchText"
               autocomplete="off"
               :disabled="disabled" />
        <div class="dropdown-menu dropdown-list" v-if="!disabled" @scroll="onScroll" :key="dropdownKey">
            <div v-for="(item, i) of dropItems" class="dropdown-menu-item" v-if="!item.Hidden">
                <input :id="idPref + i" value="true" type="checkbox"
                       class="input-checkbox"
                       @click="onSelect(item, i, $event)"
                       v-model="item.Checked" />
                <label :for="idPref + i" class="input-checkbox-lbl">{{ item[textField] }}</label>
            </div>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'

    function isOverflown(element) {
        if (!element) {
            return false;
        }
        //console.info('[element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]',
        //    [element.scrollHeight, element.clientHeight, element.scrollWidth, element.clientWidth]);
        return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
    }

    export default {
        name: "checked-down",

        props: ['name', 'value', 'items', 'dataField', 'textField', 'idPref', 'disabled', 'loadFunction', 'hasErrors', 'rowsPage'],

        $_veeValidate: {
            value() {
                let selectedItem = _.filter(this.dropItems, { Checked: true });
                //let val = selectedItem.length ? selectedItem[0][this.dataField] : null;
                //return val;
                return selectedItem;
            },
            name() {
                return this.name;
            }
        },

        data() {
            return {
                dropDownOpen: false,
                dropItems: [],
                tempItems: [],
                isOverflown: false,
                selectedText: '',
                searchText: null,
                dropdownKey: 0,
                selectAll: false,
                page: 1,
                loading: false,
                canBeLoaded: true
            }
        },

        watch: {
            items() {
                //console.info('dd -> watch items changed');
                this.tempItems = this.items;
                this.setItems();
            },
            value(newVal, oldVal) {
                //console.info('dd -> watch value: newVal, oldVal', [newVal, oldVal]);
            },
            name(newVal, oldVal) {
                //console.info('dd -> watch name: newVal, oldVal', [newVal, oldVal]);
                this.dropItems = [];
                this.selectAll = false;
            },
            dropDownOpen() {
                let vm = this;
                if(vm.dropDownOpen) {
                    vm.$nextTick(() => {
                        vm.isOverflown = isOverflown($(vm.$el).parents('.block-in-page-detail:first').get(0));
                    });
                } else {
                    vm.isOverflown = false;
                }
            }
        },

        methods: {
            calculateSelecteditem() {
                let vm = this;
                vm.selectedText = '';
                if (this.dropItems === undefined) {
                } else {
                    for (let i = 1; i < vm.dropItems.length; i++) {
                        if (vm.dropItems[i].Checked) {
                            vm.selectedText = vm.selectedText + '; ' + vm.dropItems[i][vm.textField];
                        }
                    }
                    if (vm.selectedText.length > 2)
                        vm.selectedText = vm.selectedText.substring(2);
                }
                //console.info('dd -> calculateSelecteditem', vm.selectedText);
            },

            onSelect(item, i, event) {
                let vm = this;
                let el = this.dropItems[i];
                let emitOnBottomScrolled = false;
                if(el[vm.textField] === 'Выбрать всех') {
                    vm.selectAll = event.srcElement.checked;
                    emitOnBottomScrolled = vm.selectAll;
                    for(let j = 0; j < vm.dropItems.length; j++) {
                        vm.dropItems[j].Checked = vm.selectAll;
                        //vm.$set(vm.dropItems, j, vm.dropItems[j]);
                    }
                } else {
                    el.Checked = event.srcElement.checked;
                    //vm.$set(vm.dropItems, i, el);
                    if(vm.dropItems[0].Checked) {
                        vm.selectAll = false;
                        vm.dropItems[0].Checked = vm.selectAll;
                        //vm.$set(vm.dropItems, 0, vm.dropItems[0]);
                    }
                }
                this.calculateSelecteditem();

                let selectedItems = _.filter(this.dropItems, function (val, key, obj) {return key > 0 && val.Checked;});
                this.$emit('input', selectedItems);
                this.$emit('change', selectedItems);
                if(emitOnBottomScrolled) {
                    this.$emit('onBottomScrolled', true);
                }
            },

            setItems() {
                let vm = this;
                vm.dropItems = [{[vm.textField]: 'Выбрать всех', Checked: vm.selectAll, [vm.dataField]: null}];

                for(let item of vm.tempItems) {
                    if(item.Checked)
                        vm.dropItems.push(Object.assign({Checked: true}, item));
                    else
                        vm.dropItems.push(Object.assign({Checked: vm.selectAll}, item));
                }
                if(vm.selectAll) {
                    let selectedItems = _.filter(vm.dropItems, function (val, key, obj) {return key > 0;});
                    vm.$emit('input', selectedItems);
                    vm.$emit('change', selectedItems);
                } else {
                    let selItem = [];
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        let el = vm.dropItems[i];
                        if(vm.dataField && el[vm.dataField]) {
                            selItem = _.filter(vm.value, function (item) {return item[vm.dataField] == el[vm.dataField];});
                        }
                        else {
                            selItem = _.filter(vm.value, function (item) {return item[vm.textField] == el[vm.textField];});
                        }
                        if(selItem.length) {
                            el.Checked = true;
                        }
                    }
                }
                this.calculateSelecteditem();
            },

            onClickOutside(e, el) {
                this.dropDownOpen = false;
            },

            onScroll(e) {
                let vm = this;
                if(!vm.loading && vm.canBeLoaded) {
                    let elem = $(e.target);
                    if(elem[0].scrollHeight - elem.scrollTop() <= elem.outerHeight() + 100) {
                        this.$emit('onBottomScrolled', false);

                        vm.page++;
                        vm.loadNext();
                    }
                }
            },

            onChangeSearchInput: _.debounce(function ($event) {
                let vm = this;

                if(vm.searchText === '') {
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        vm.dropItems[i].Hidden = false;
                    }
                }
                else {
                    let textLower = vm.searchText.toLowerCase();
                    for(let i = 0; i < vm.dropItems.length; i++) {
                        let el = vm.dropItems[i];
                        el.Hidden = el[vm.textField].toLowerCase().indexOf(textLower) === -1
                    }
                }

                vm.dropdownKey++;
            }, 500),

            loadNext() {
                let vm = this;
                if(!vm.dropDownOpen || !vm.loadFunction)
                    return;
                vm.loading = true;
                vm.loadFunction(vm.searchText, function (res) {
                    //console.info('checkedown-loadFunction', res);
                    if(res) {
                        if(res.length) {
                            if(vm.page == 1) {
                                vm.tempItems = Object.assign(res);
                            } else {
                                //vm.tempItems.push(...Object.assign(res));
                                for(let resitem of res) {
                                    if(_.filter(vm.tempItems, function (item) {return item[vm.textField] == resitem[vm.textField];}).length === 0) {
                                        vm.tempItems.push(Object.assign(resitem));
                                    }
                                }
                            }
                            vm.setItems();
                            if(vm.rowsPage > res.length) {
                                let selectedItems = _.filter(vm.dropItems, function (val, key, obj) {return key > 0 && val.Checked;});
                                vm.$emit('input', selectedItems);
                                vm.$emit('change', selectedItems);
                            }
                        }
                        else {
                            vm.canBeLoaded = false;
                        }
                    }
                    vm.loading = false;

                }, vm.page, vm.selectAll);
            },

            onDropDownOpen() {
                let vm = this;
                if(vm.dropDownOpen)
                    return;
                vm.dropDownOpen = true;
                vm.page = 1;
                vm.loadNext();
            }
        },

        mounted() {
            this.tempItems = this.items;
            this.setItems();
        },

        destroyed() {

        }
    }
</script>

<style scoped>
    .dropdown-block .dropdown-menu-item-selected {
        max-width: 550px;
        display: inline-block;
    }
    .dropdown-block .input-text {
        min-height: auto;
        border: none;
        padding: 0px;
    }
    .dropdown-block.dropdown-error {
        border-color: #ef0348;
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/CheckedDown.vue